import React from 'react';

const Forbidden = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>403 - Forbidden</h1>
            <p>Sorry, you do not have permission to access this page.</p>
        </div>
    );
};

export default Forbidden;
